export default __webpack_public_path__ + "static/media/bogdan-gheorghe.13352b70.png";